import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { testId } from '@lojinha/helpers';
import { Anchor } from '../../';
const Wrapper = styled.div `
  position: relative;
`;
const Dropwdown = styled.div(({ theme }) => `
    position: absolute;
    bottom: 0;
    width: 288px;
    box-shadow: ${theme.shadows.gray16};
    border-radius: ${theme.space.x8};
    background: white;
    left: 50%;
    transform: translate(-50%, 100%);
    z-index: 1;
    overflow-y: auto;
    max-height: 500px;
  `, ({ isActive }) => {
    if (isActive)
        return `
        transition: background-color 200ms ease, opacity 300ms ease;
        opacity: 1;
      `;
    return `
      opacity: 0;
      visibility: hidden;
      transition: background-color 200ms ease, opacity 300ms ease;
    `;
});
export const MenuDropdown = ({ anchorElement, children, route, }) => {
    const [isDropdownOpened, setIsDropdownOpened] = useState(false);
    const dropdownRef = useRef(null);
    const containerRef = useRef(null);
    const openDropdown = () => setIsDropdownOpened(true);
    const closeDropdown = () => setIsDropdownOpened(false);
    const closeDropdownOnBlur = (event) => {
        const { relatedTarget } = event;
        const blurOnMenuItem = containerRef.current && containerRef.current.contains(relatedTarget);
        if (!blurOnMenuItem) {
            closeDropdown();
        }
    };
    const redirectFocusToContainer = () => {
        if (containerRef.current) {
            containerRef.current.focus();
        }
    };
    const redirectFocusToDropdown = () => {
        if (dropdownRef.current) {
            dropdownRef.current.focus();
        }
    };
    const handleWrapperFocus = (_event) => {
        openDropdown();
    };
    const handleWrapperMouseOver = (_event) => {
        openDropdown();
    };
    const handleWrapperKeyDown = (event) => {
        const { key } = event;
        if (!['Tab', 'Enter', 'Escape'].includes(key)) {
            event.preventDefault();
        }
        if (key === 'Escape') {
            closeDropdown();
        }
        if (['ArrowDown', 'ArrowUp'].includes(key)) {
            setIsDropdownOpened(true);
            redirectFocusToDropdown();
        }
    };
    const handleDropdownKeyDown = (event) => {
        const { key } = event;
        if (key === 'Escape') {
            redirectFocusToContainer();
            closeDropdown();
        }
    };
    return (React.createElement(Wrapper, { ref: containerRef, onMouseOut: closeDropdown, onBlur: closeDropdownOnBlur, onFocus: handleWrapperFocus, onMouseOver: handleWrapperMouseOver, onKeyDown: handleWrapperKeyDown, ...testId('dropdown-wrapper') },
        React.createElement(Anchor, { color: "inherit", isBlock: true, htmlAttrs: {
                tabIndex: 0,
            }, href: route, ...testId('dropdown-anchor') }, anchorElement),
        React.createElement(Dropwdown, { ref: dropdownRef, isActive: isDropdownOpened, onKeyDown: handleDropdownKeyDown, onBlur: closeDropdownOnBlur, onMouseOut: closeDropdown, ...testId('dropdown-container') }, children)));
};
//# sourceMappingURL=index.js.map